<template>
	<div class="top">
		<div class="top_weather">
			<iframe width="100%" scrolling="no" height="100%" frameborder="0" allowtransparency="true" src="https://i.tianqi.com?c=code&id=6&color=%23333333&bdc=%23&icon=1&py=ziyang&site=12"></iframe>
		</div>
		<div class="logo_box">
			<img class="logo" src="../static/home/logo.png" alt="">
		</div>
		<div class="top_option">
			<div :class="p==index?'option_boxcode':'option_box'" v-for="(item,index) in list" :key="index" @click="nvu(index)">
				<img class="top_img" :src="listimg[index]" alt="">
				<div class="option_cn">
					【{{item.label}}】
				</div>
				<div class="option_en" v-if="lang==1">
					{{listen[index]}}
				</div>
			</div>
		</div>
		<div class="lang_box">
			<div :class="lang==1?'lang_min':'lang_mincode'" @click="langss(1)">
				中文
			</div>
			<div :class="lang==2?'lang_min':'lang_mincode'" @click="langss(2)">
				EN
			</div>
			<div :class="lang==3?'lang_min':'lang_mincode'" @click="langss(3)">
				JP
			</div>
			<div :class="lang==4?'lang_min':'lang_mincode'" @click="langss(4)">
				KR
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'top',
	  props: {
	        p: Number,
	        required: true
	  },
	  data() {
	  	return {
			lang: 1,
			
			list:[],	
			listen:["home","ABOUT US","landscape","picture","Scenery","virtual","News","Service","Online","contact us",],
			listimg:[
				require('../static/home/top1.png'),
				require('../static/home/top2.png'),
				require('../static/home/top3.png'),
				require('../static/home/top4.png'),
				require('../static/home/top5.png'),
				require('../static/home/top6.png'),
				require('../static/home/top7.png'),
				require('../static/home/top8.png'),
				require('../static/home/top9.png'),
				require('../static/home/top10.png'),
			]
	  	}
	  },
	  created() {
		  this.lang = JSON.parse(localStorage.getItem("langs")) || 1
			
			this.$axios({
			        url:"/api"+"/site/menu/tree?lang=" + this.lang ,//请求的后台接口
			        method:"get",//get请求方式
					headers:{
						'User-Request-Type': 'riesun_site', 
						'siteid' : 'riesun_site_caa20f63ab704743b21741ba133e8499',
						'sitesecret' : '03569e80-00b6-4540-9e65-0a53f0f2ab7e',
					},
					params:{
						'siteType':1
					} //传给后台的参数
			    }).then(res=>{
					//头部菜单
					this.list = res.data.data
					localStorage.setItem("ids", JSON.stringify(this.list));
					// console.log(JSON.parse(JSON.stringify(res.data.data)))
			　　//请求成功
			}).catch(error=>{
					console.log(error)
			});
			
			
	  },
	  methods:{
		 nvu(e){
			 if(e==0){
				 if(this.$route.name == 'home'){
				 	this.$router.replace('/refresh')
				 }else{
				 	this.$router.push({name:'home',query:{nums:0}})
				 }
			 }
			 if(e==1){
				 if(this.$route.name == 'overview'){
				 	this.$router.replace('/refresh')
				 }else{
				 	this.$router.push({name:'overview',query:{nums:0}})
				 }
			 }
			 if(e==2){
				 if(this.$route.name == 'scenic'){
					this.$router.replace('/refresh')
				 }else{
					this.$router.push({name:'scenic',query:{nums:0}})
				 }
			 }
			 if(e==3){
				 if(this.$route.name == 'picture'){
					this.$router.replace('/refresh')
				 }else{
					this.$router.push({name:'picture',query:{nums:0}})
				 }
			 }
			 if(e==4){
				 if(this.$route.name == 'scenery'){
					this.$router.replace('/refresh')
				 }else{
					this.$router.push({name:'scenery',query:{nums:0}})
				 }
			 }
			 if(e==5){
				 window.open('https://www.720yun.com/vr/182jO7kkva8',"_blank");
			 }
			 
			 if(e==6){
				 if(this.$route.name == 'news'){
					this.$router.replace('/refresh')
				 }else{
					this.$router.push({name:'news',query:{nums:0}})
				 }
			 }
			
			 if(e==7){
				 if(this.$route.name == 'service'){
					this.$router.replace('/refresh')
				 }else{
					this.$router.push({name:'service',query:{nums:0}})
				 }
			 }
			 
			 if(e==8){
				 if(this.$route.name == 'online'){
					this.$router.replace('/refresh')
				 }else{
					this.$router.push({name:'online',query:{nums:0}})
				 }
			 }
			 if(e==9){
				 if(this.$route.name == 'contact'){
					this.$router.replace('/refresh')
				 }else{
					this.$router.push({name:'contact',query:{nums:0}})
				 }
			 }
			 
		 },
		  
		langss(e){
			this.lang = e		//选择语言文字  第几个
			localStorage.setItem("langs", e);
			this.$axios({
			        url:"/api"+"/site/menu/tree?lang=" + this.lang ,//请求的后台接口
			        method:"get",//get请求方式
					headers:{
						'User-Request-Type': 'riesun_site', 
						'siteid' : 'riesun_site_caa20f63ab704743b21741ba133e8499',
						'sitesecret' : '03569e80-00b6-4540-9e65-0a53f0f2ab7e',
					},
					params:{
						'siteType':1
					} //传给后台的参数
			    }).then(res=>{
					//头部菜单
					var ids = res.data.data
					localStorage.setItem("ids", JSON.stringify(ids));
					this.$router.go(0)
			　　//请求成功
			}).catch(error=>{
					console.log(error)
			});
			
		},
		  
	  },
	  
	  beforeDestroy(){	//退出页面时间
	  		
	  }
	  
	}
</script>

<style scoped lang="less">
	//
	.top{
		height: 150px;
		width: 1920px;
		background-image: url('../static/home/150.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		
		display: flex;
		cursor:pointer;
		
		position: absolute;
		top: 0;
		left: 0;
		z-index: 10;
	}
	.top_weather{
		width: 150px;
		height: 90px;
		margin: 20px 0 0 36px;
		overflow: hidden;
	}
	.logo_box{
		width: 88px;
		height: 88px;
		margin-top: 10px;
		.logo{
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
	
	.top_option{
		display: flex;
		width: 1300px;
		height: 105px;
		margin-left: 70px;
		justify-content: center;
		overflow: hidden;
		transition:1s all;
	}
	.option_box{
		padding: 20px 10px 0 10px;
		transition:0.4s all;
	}
		.option_box:hover{
			background-color: rgba(0, 0, 0, .1);
		}
	.option_boxcode{
		padding: 20px 10px 0 10px;
		background-color: rgba(0, 0, 0, .1);
	}
	.option_cn{
		font-family: "楷体";
		font-size: 18px;
		line-height: 18px;
		margin-top: 4px;
		color: #000000;
		text-align: center;
		white-space: nowrap;       //超出不换行
		text-transform:uppercase ; 
	}
	.option_en{
		font-size: 12px;
		line-height: 12px;
		margin-top: 4px;
		color: #333333;
		text-align: center;
		white-space: nowrap;       //超出不换行
		text-transform:uppercase ; 
	}
	
	.top_img{
		width: 42px;
		height: 42px;
		display: block;
		margin: auto;
	}
	
	
	
	.lang_box{
		height: 34px;
		display: flex;
		margin-top: 42px;
	}
	.lang_min{
		height: 34px;
		line-height: 34px;
		width: 36px;
		text-align: center;
		border-radius: 10px;
		background-image: url('../static/home/en.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		font-size: 12px;
		color: #000;
		font-family: "微软雅黑";
		margin-right: 16px;
	}
	.lang_mincode{
		height: 34px;
		line-height: 34px;
		width: 36px;
		text-align: center;
		border-radius: 10px;
		background-image: url('../static/home/cn.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		font-size: 12px;
		color: #fff;
		font-family: "微软雅黑";
		margin-right: 16px;
	}
</style>